// extracted by mini-css-extract-plugin
module.exports = {"dialogBtnBox":"payRiskModal_dialogBtnBox__sctoh","primaryBtn":"payRiskModal_primaryBtn__rUjTX"};